<template>
  <AbsPopup id="ChangeWork" title="이동할 저작공간을 선택해 주세요" type="confirm" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div v-for="item in workList" class="workinfo" :key="item.index" >
          <div v-if="!item.name" class="notwork">
            없음
          </div>
          <div v-else :class="getWorkType(item)" @click="selected(item)">
            <span>{{ item.name }}</span>
            <span v-if="item.state & 128" class="require">(삭제중 {{ Math.ceil(item.deletedate) }}일 남음)</span>
            <div class="abs">
              <icon v-if="isVisible(item)" size="xxsmall" uicon="123"/>
              <icon v-if="isMainopen(item)" size="xxsmall" uicon="107"/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import TabBar from '@/components/layout/TabBar.vue'
import {State} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
    console.log(this.option.param)
    this.$http.post('/api/library/worklist', {id: this.option.param.book.user._id}).then((e) => {
      console.log(e)
      if (e.success) {
        this.workList = []
        for (var i = 0; i < 3; i++) {
          if (e.data[i]) {
            e.data[i].index = i
            console.log(e.data[i].name, e.data[i].state & State.VISIBLE, e.data[i].state & State.MAINOPEN)
            this.workList.push(e.data[i])
            if (this.option.param.book.work === e.data[i]._id) {
              this.workinit = i
            }
          } else {
            this.workList.push({index: i})
          }
        }
      } else {
      }
      this.$emit('loading', false)
    })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  data () {
    return {
      workList: [],
      workinit: -1
    }
  },
  name: 'ChangeWork',
  watch: {
  },
  computed: {
  },
  methods: {
    getWorkType (item) {
      if (item.state & State.DELETE) {
        return 'delete'
      }
      if (this.workinit === item.index) {
        return 'select'
      }
      if (item.state & State.VISIBLE) {
        return 'offtab'
      }
      return 'tab'
    },
    isVisible (item) {
      return Boolean(item.state & State.VISIBLE)
    },
    isMainopen (item) {
      console.log(Boolean(item.state & State.MAINOPEN))
      return Boolean(item.state & State.MAINOPEN)
    },
    isDelete (item) {
      return Boolean(item.state & State.DELETE)
    },
    selected (e) {
      console.log(e)
      if (!this.isDelete(e)) {
        this.workinit = e.index
      }
    },
    submit () {
      this.$emit('submit', this.workList[this.workinit])
    }
  },
  components: {
    AbsPopup,
    TabBar
  }
}
</script>

<style scoped>
#ChangeWork {
  padding: 10px 0;
  width: 400px;
}
.popup-body {
  display: flex;
  width: 100%;
  padding: 10px;
  flex-direction: column;
}
.workinfo {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.workinfo:nth-child(1n+2) {
  margin-top: 5px;
}
.workinfo .notwork {
  border: dashed 1px var(--text-guide);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--line-guide);
  cursor: default;
}
.workinfo > div {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.workinfo .select {
  background-color: var(--line-title);
  color: var(--bg-white);
  cursor: default;
}
.workinfo .tab {
  border: solid 1px var(--line-title);
  color: var(--text-title);
  cursor: pointer;
}
.workinfo .tab:hover, .workinfo .offtab:hover {
  background-color: var(--line-guide);
  border: solid 1px var(--line-guide);
  color: var(--bg-white);
}
.workinfo .offtab {
  border: solid 1px var(--line-base);
  color: var(--text-base);
  cursor: pointer;
}
.workinfo .delete {
  border: solid 1px var(--require);
  color: var(--text-base);
  flex-direction: column;
  cursor: default;
}
.workinfo .delete .require {
  font-size: 12px;
}
.workinfo .abs {
  position: absolute;
  right: 5px;
  display: flex;
  flex-direction: row;
  top: 5px;
}
.workinfo .abs span:nth-child(1n+2) {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ChangeWork.vue